/**
 * VeigarPainter — 2D tiny dark mage silhouette (hat + orb).
 */
export const VeigarPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, radius * 0.15, radius * 0.75, 0, Math.PI * 2);
    ctx.fillStyle = '#1e1b4b';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.35, radius * 0.35, 0, Math.PI * 2);
    ctx.fillStyle = '#312e81';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(-radius * 0.55, -radius * 0.45);
    ctx.lineTo(0, -radius * 1.25);
    ctx.lineTo(radius * 0.55, -radius * 0.45);
    ctx.closePath();
    ctx.fillStyle = '#7c3aed';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(radius * 0.7, radius * 0.1, radius * 0.28, 0, Math.PI * 2);
    ctx.fillStyle = '#a78bfa';
    ctx.fill();
  }
};
